module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "p3",
      "title": "3"
    }
  }, [_c('div', {
    staticClass: "figure2"
  }, [_c('figure', [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/p003.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_vm._v("Hello Friends,")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent1"
  }, [_vm._v("We get it—lives are busy and time is short. Just when there’s no time for making a home-cooked meal, you know you’re going to get that dreaded question . . . what’s for dinner? Prepare yourselves for days like these with meals or ingredients you’ve prepped and thrown in the freezer, making homemade possible—even on your busiest days. This book is filled with recipes for delicious make-ahead meals and great tips that make it simple to do.")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("From breakfast to dinner (and not forgetting dessert) you’ll find yummy recipes that will excite taste buds and satisfy like no frozen boxed pizza can do. "), _c('span', {
    attrs: {
      "href": "#/html/p216#p216",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Quick Freezer Ideas")]), _vm._v(", will not only help you make meals in advance, but also to take advantage of sales at the grocery store and freeze foods so they won’t go to waste. And check out the feature on "), _c('span', {
    attrs: {
      "href": "#/html/p092#p92",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Slow-Cooker-Ready Freezer Bags")]), _vm._v(". We’ll show how to make meals you prep and freeze—all ready to dump in your slow cooker, turn it on . . . and go!")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('span', {
    attrs: {
      "href": "#/html/p134#p134",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Host a Freezer Meal Party")]), _vm._v(", gives you everything you’ll need to throw one of these popular get-togethers. Who wouldn’t love to be at a party where you get to chat, nibble and sip wine . . . all while preparing meals that everyone can take home to put in their freezers? We’ll also show you how to turn it into a party with a purpose—making meals that can help out those in need in your community!")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("So dive in, get started and stock your freezer. Homemade meals will be at your fingertips whenever you’re hungry and short on time.")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "nonindent5"
  }, [_vm._v("Look for these helpful icons:")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent3"
  }, [_c('span', {
    staticClass: "grey"
  }, [_vm._v("[")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("QUICK PREP")]), _vm._v(" "), _c('span', {
    staticClass: "grey"
  }, [_vm._v("]")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_c('span', {
    staticClass: "light"
  }, [_vm._v("(15 minutes or less)")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent3"
  }, [_c('span', {
    staticClass: "grey"
  }, [_vm._v("[")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("SLOW COOKER")]), _vm._v(" "), _c('span', {
    staticClass: "grey"
  }, [_vm._v("]")])])]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("Let’s get chopping!")]), _vm._v(" "), _c('div', {
    staticClass: "figure3"
  }, [_c('figure', [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/p003c.png"
    }
  })])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a3c820b6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/p003.vue
// module id = 63
// module chunks = 0